import { Component, EventEmitter, Query, ViewChild, Output, Input, ViewChildren, ContentChildren, Directive, ElementRef, QueryList, OnInit, trigger, state, animate, style, transition, keyframes, group } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { featuresBox, CartOverlay, featureslist, listAnimation, fadeIn } from '../../store/animations';
import { overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, paymenticon, accountpayment, terms, paypalpayment, giftwindow, giftpayment, giftcontainer, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewSwitch, viewOptionList, viewDetails, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewInfoItem, viewInfoText, taglineSpan, taglineField, viewItems, gamecopies, newsWindow, actionsMenu }  from '../animations.overlay';
import { Http, Response, Headers } from '@angular/http';

import { Filter } from '../../models/filter.constructor';

import { AppComponent } from '../../app.component';
import { UserService } from '../../services/user.service';
import { StoreService } from '../../services/store.service';
import { environment } from '../../environment';

// Products
import { Account } from '../../models/account';
import { Claim } from '../../models/claim';
import { Order } from '../../models/order';
import { Product } from '../../models/product';
import { News } from '../../models/news';
import { Item } from '../../models/item';



@Component({
  selector: 'user-claims',
  templateUrl: './user.claims.html',
  providers: [ UserService ],
  inputs: [ 'reloadClaims' ],
  outputs: [ 'giftingproduct', 'sharelisting' ],
  animations: [ CartOverlay, featuresBox, overlay, paymentmethod, paymenterror, details, share, payment, paymentresult, paymenticon, accountpayment, terms, paypalpayment, giftwindow, giftpayment, giftcontainer, giftresult, agreement, gifticon, editProfile, editAddress, editPassword, editEmail, editUsername, viewOptionBlock, viewOptionList, viewDetails, viewSwitch, viewFade, viewOwner, viewIcons, viewIconicText, viewBeta, viewOption, viewDesc, viewInfo, viewInfoItem, viewInfoText, taglineSpan, taglineField, viewItems, gamecopies, newsWindow, featureslist, actionsMenu ]
})
export class UserCliamsComponent implements OnInit {

	@Output() giftingproduct: EventEmitter<Product> = new EventEmitter();
	@Output() sharelisting: EventEmitter<Product> = new EventEmitter();
	@Input() reloadClaims = false;
	
	/* Header Tokens */
	public token: any;
	header: any;
	title: string;
	subtitle: string;
	showNews = false;
	showDetails = 'false';
	showFeatures = false;
	
	profile = new Profile();
	credit = new CreditCard('', null, null, '', 1, false);
	
	addAmount = new Amount(20);

	/* Models */
	sort: any;
	cat: any;
	query = new Filter('', '', '');
	filterItems = new Filter('', '', '');

	showOwned = true;

	accounts: Account;
	products: Product;
	features: Product;
	confirmPackage: Product;
	claims: Claim;
	news: News;
	order: Order;
	giftorder: Order;
	items: Item;
	environment = environment;


	// Settings for 'Show More...' links
	expandedChars = 100000;
	condensedChars = 400;
	limit = [this.condensedChars, this.condensedChars];
	
	/* Overlay */
	productquery = new Filter();
	gift = new Gift('', false);
	showFixture = 'false';
	fixture = '1';
	totalClaims = 0;
	show = 0;

	ownprofile: boolean;
	error: number;
	image: any;
	requests: any;
	orderPage: any;
	oAuthtimer: any;
	hasProducts: any;
	lastViewPanel: any;
	numberOfClaims = 0;
	showActions = [];
	viewPanel = [];
	viewMode: any;
	now: any;
	hideFeatured = true;
	flashCart = false;
	loadingCart = false;
	showProductDetails = 'false';
	selectedProduct = 0;
	selectedImage = 0;
	selected = 0;

	errorCode = 0;
	errorMsg = '';

	x = 0;
	y = 0;
	

	constructor(private http : Http,
				private user: UserService,
  			  	private store: StoreService,
				private router: Router,
  			  	private route: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private cookie: CookieService) { 

		this.hasProducts = 'null';
		for (var i = 10; i >= 0; i--) {
			this.viewPanel[i] = 'desc';
		}

	}

	/**
	* Page Handling
	**/

	ngOnChanges(changes) {
		if (changes.reloadClaims) {
			this.fetchUserInfo();
		}
	}

	authorize() {
		// Authorize a user
		this.user.authorizeUser().subscribe((user) =>  {
			this.accounts = user;
			this.title = this.accounts[0].username;
			this.subtitle = this.accounts[0].tagline;
		});
	}

	// reload() {
	// 	this.fetchUserInfo();
	// }

	changeViewMode(v) {
		this.viewMode = v;
		this.cookie.put('view', v, { expires: this.now });
		if ( this.viewMode == 'list') {
			this.lastViewPanel = this.viewPanel;
			this.viewPanel = ['info'];
		} else { // block
			this.viewPanel = ['desc'];
		}
	}


	// showTerms() {
	// 	this.orderPage = this.fixture;
	// 	this.fixture = '4';
	// }

	showTerms() {
		this.orderPage = this.fixture;
		this.fixture = '11';
	}

	backToOrder() {
		this.fixture = this.orderPage;
	}

	giftItem(listing) {
		this.giftingproduct.emit(listing);
	}

	shareItem(listing) {
		this.sharelisting.emit(listing);
	}

	addToCart(product) {
		if (product.instock) {
			this.store.addToCart(product.id);
			this.updateCartButton();
		}
	}

	removeFromCart(productIndex) {
		this.store.removeFromCart(productIndex);
	}

	updateCartButton() {
	 	this.flashCart = true;
	 	setTimeout( () => { this.flashCart = false;  }, 5000);
	}

	inCart() { 
		return false;
	}

	getNews(): Promise<News> {
		return this.http
			.get(`${environment.baseUrl}/updates/`)
			.toPromise()
			.then(mapNews)
			.catch((err) => {
				// toss
			})
  	}

	fetchUserInfo() {

		// Get the users products
		Promise.resolve( this.store.getPurchasedProducts() ).then( (product) => {

			this.products = product;
			if ( product[0] ) this.hasProducts = 'true';
			if ( !product[0] ) this.hasProducts = 'false';

			// Get the users products
			Promise.resolve( this.store.getPurchasedProductsCount() ).then( (count) => {
				this.numberOfClaims = count;
			}).catch(function (err) { });

		}).catch(function (err) { });

		// Get the user's claims
		Promise.resolve(this.user.getClaims()).then( (usersClaims) => {
			this.claims = usersClaims;
		}).catch(function (err) { });

	}


	showProduct(i) {
		this.showDetails = 'true'; 
		this.selectedProduct = i;
	}


	/* On with the show */
	ngOnInit() {
		// this.viewMode = this.cookie.get('view') ? this.cookie.get('view') : 'list';

		this.authorize();
		this.fetchUserInfo();

		this.subtitle = '';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url("/assets/img/header-square.jpg")' );

		Promise.resolve(this.store.loadProducts()).then( (featuredProducts) => {
			this.features = featuredProducts;
		});

		Promise.resolve(this.getNews()).then( (newsItems) => {
			this.news = newsItems;
		});

	}


    flipView(i) {
	    this.viewPanel[i] = (this.viewPanel[i]=='desc') ? 'info' : 'desc';
    }

}

// Export the constructor Login form
export class Profile {

	constructor(
		public firstname?: string,
		public surname?: string,
		public email?: string,
		public tagline?: string,
		public password?: string,
		public birthday?: string,
		public sex?: string,
		public street?: string,
		public housenumber?: string,
		public zip?: string,
		public city?: string,
		public state?: string,
		public countrycode?: string
	) {}

}
// This constructor generates the Login form
export class CreditCard {

  constructor(
	private cardholderName: string,
	private cardNumber: number,
	private cvv: number,
	private expiryDate: string,
	private paymentProductId: any,
	public terms: boolean
  ) {}

}

export class Amount {
	constructor(
		public amount?: number
	) {}
}
export class Gift {

	constructor(
		public username?: string,
		public release?: boolean
	) {}

}

/**
* 		Managing news items
**/

function mapNews(response?:Response): News {
	let res = response.json().map(toNewsFeed);
	return res;
}

function toNewsFeed(r?:any): News {
	let newsItems = <News>({
		tid: r.tid,
		title: r.title,
		title_seo: r.title_seo,
		start_date: r.start_date,
		starter_id: r.starter_id,
		starter_name: r.starter_name,
		topic_firstpost: r.topic_firstpost,
		post: r.post,
		url: r.url,
		author_url: r.author_url,
		comments_url: r.comments_url
	});
	return newsItems;
}



// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/user/user-claims/user.claims.component.ts